import { render } from "./KeyStorageSelector.vue?vue&type=template&id=c95b6c7a&ts=true"
import script from "./KeyStorageSelector.vue?vue&type=script&lang=ts"
export * from "./KeyStorageSelector.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__